export default __webpack_public_path__ + "static/carousel3-0ce4f73e67273964658bdb26a3ebd2f8.webp";